import SignInScreen from './FirebaseSignIn';

export default function LoginPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded shadow-md w-full max-w-sm">
        <h2 className="text-2xl font-bold mb-6 text-center">התחברות / הרשמה</h2>
        <SignInScreen />
        <div className="mb-4">
          {/* Apple login is not as straightforward for web, so this is a placeholder */}
        </div>
        {/* Optionally add email/password fallback here */}
      </div>
    </div>
  );
}
